import EventActionProto from '../event-action-proto'

module.exports = class EventTaskTypeResetByCompany extends EventActionProto {

    constructor(uid, data) {
        super(uid, data);
        this.restartApps = ['organization-settings-task-types','organization-settings-task-type'];
    }

    validate() {
        return true;
    }

    process() {
        const companyId = this.data[0].companyId
        gd.session.taskTypes.resetAndMarkOldModelsAsDeleted(this.data, companyId)

        super.process()
    }
};

